import { Directive, inject } from '@angular/core';
import { DataGridHostBase as KitDataGridHostBase } from '@sensika/ag-grid-kit';
import { OBJECT_EDITOR_SERVICE } from 'src/app/core/services/object-editor.token';

/**
 * The web app's grid host base: the kit's base with the full ObjectEditorService
 * bound where the kit only knows an optional `editUser`. Hosts extend this one;
 * the token keeps the import graph acyclic (WAP-1680).
 */
@Directive()
export abstract class DataGridHostBase extends KitDataGridHostBase {
  protected override readonly objectEditor = inject(OBJECT_EDITOR_SERVICE);
}
